<script>
import modalMixin from '@phoenix/mixins/modalMixin';
import ProductSlider from '@maison/components/organisms/ProductSlider.vue';
import { get } from 'lodash-es';
import { clientApi } from '@phoenix/clientApi';
import CurrentCountry from '@phoenix/components/CurrentCountry';

export default {
  components: { ProductSlider },
  mixins: [modalMixin],

  props: {
    strapReference: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      products: [],
      productsGroupBySize: {},
      selectedSize: '',
    };
  },

  computed: {
    modalOptions() {
      return {
        onShow: (event) => this.setProps(this.getModalProps(event)),
      };
    },

    hasFilteredProductPages() {
      return this.filteredProductPages && this.filteredProductPages.length > 0;
    },

    filteredProductPages() {
      if (this.selectedSize === '') {
        return [];
      }

      const currentProducts = this.productsGroupBySize[this.selectedSize]?.map((data) => data.product) ?? [];

      return this.products.filter((product) => currentProducts.includes(product.modelReference));
    },
  },

  async mounted() {
    const watchReference = new URLSearchParams(window.location.search).get('engraved-reference') ?? null;

    const {
      data: { data },
    } = await clientApi.get(window.route('api.search.relatedStraps'), {
      params: {
        watchReference,
        strapReference: this.strapReference,
      },
    });

    this.products = data.similarStrapPages ?? [];
    this.productsGroupBySize = data.similarStrapsBySize ?? {};
    this.countryReveal();
  },

  methods: {
    countryReveal() {
      const currentCountry = new CurrentCountry();
      const items = this.$refs?.mainContent?.$el.querySelectorAll(CurrentCountry.COUNTRY_REVEAL_CONTAINER);
      const currentCountryCode = window.Phoenix.currentCountry;

      if (!items || !currentCountryCode || currentCountryCode === '') {
        return;
      }

      Array.from(items).forEach((container) => {
        currentCountry.revealCountryForElement(currentCountryCode, container);
      });
    },

    setProps(props) {
      this.selectedSize = get(props, 'size');
    },
  },
};
</script>
<template>
  <modal
    :id="id"
    ref="mainContent"
    :title="$t('StrapSizeFinder.contact.modal.title')"
    :content-classes="['out-of-stock-contact-modal-content']"
    :options="modalOptions"
    header-bordered
    class="out-of-stock-contact-modal"
  >
    <template #content>
      <slot name="content" />
      <div v-if="hasFilteredProductPages" class="out-of-stock-contact-modal__slider-wrapper">
        <div class="h4">{{ $t('StrapSizeFinder.contact.modal.similarStraps') }}</div>
        <product-slider slider-id="products-slider" :product-pages="filteredProductPages" />
      </div>
      <div v-else class="mt-md"></div>
    </template>
  </modal>
</template>
